import NhncommerceIcon from "@/components/common/icon/nhncommerce-icon";
import { SITE_INTEGRATION_TYPE } from "@shared/common/constant/site";
import { X } from "lucide-react";

const SiteIntegrationHeaderPrefix = ({
  type,
}: {
  type: SITE_INTEGRATION_TYPE;
}) => {
  switch (type) {
    case SITE_INTEGRATION_TYPE.CAFE24:
      return (
        <>
          <img
            src="/images/cafe24_logo.png"
            alt="cafe24"
            style={{
              width: "116px",
              height: "21px",
            }}
          />
          <X className="w-5 h-5" />
        </>
      );

    case SITE_INTEGRATION_TYPE.NHN:
      return (
        <>
          <img
            src="/images/nhncommerce_logo.jpg"
            alt="nhn"
            style={{
              width: "124px",
              height: "27px",
              marginTop: "-11px",
            }}
          />
          <X className="w-5 h-5" />
        </>
      );

    case SITE_INTEGRATION_TYPE.MAKESHOP:
      return (
        <>
          <img
            src="/images/makeshop_logo.png"
            alt="makeshop"
            style={{
              width: "109px",
              height: "23px",
              marginTop: "-5px",
              marginRight: "-3px",
            }}
          />
          <X className="w-5 h-5" />
        </>
      );

    case SITE_INTEGRATION_TYPE.GODOMALL:
      return (
        <>
          <span className="-mt-1.5">
            <NhncommerceIcon width={72} height={15} />
          </span>
          <span className="text-base font-normal">godomall</span>
          <X className="w-4 h-4" />
        </>
      );

    case SITE_INTEGRATION_TYPE.WORDPRESS:
      return (
        <>
          <img
            src="/images/wordpress_logo_2000_680.png"
            alt="wordpress"
            style={{
              width: "120px",
              height: "41px",
            }}
          />
          <X className="w-5 h-5" />
        </>
      );

    case SITE_INTEGRATION_TYPE.SIXSHOP_PRO:
      return (
        <>
          <img
            src="/images/sixshop_pro_logo.png"
            alt="sixshop_pro"
            style={{ width: "142px" }}
          />
          <X className="w-5 h-5" />
        </>
      );

    case SITE_INTEGRATION_TYPE.SHOPIFY:
    case SITE_INTEGRATION_TYPE.SIXSHOP:
      throw new Error("Not implemented");
  }
};

export default SiteIntegrationHeaderPrefix;
